/**
 * 时间工具类
 * @author frankylli
 */

/**
  * 判断 dateStr 是否存在
  * 1. dateStr 值为 falsy 类型, 返回 null
  * 2. dateStr 值为真, 判断是否包含时间部分,不包含则加上返回
  * @param {String} [dateStr] 时间字符串, 格式: YYYY-MM-DD [HH:mm:ss]
  * @param {String} [defaultTime='00:00:00'] 时间部分
  * @return null | String
  */
export function getDatetimeOrNull(dateStr, defaultTime = '00:00:00') {
  defaultTime = defaultTime || '00:00:00'

  if (dateStr) {
    return /\d{2}:\d{2}:\d{2}/g.test(dateStr) ? dateStr : `${dateStr} ${defaultTime}`
  } else {
    return null
  }
}

const ONE_HOUR_SEC = 3600
const ONE_MINUTE_SEC = 60
// const ONE_SECOND_MILL = 1000
/**
 * 把数字转化成时间格式
 * @param {Number} number 待转化的秒,, 支持负数
 * @return [HH:]mm:ss
 */
export function numberToTime(number) {
  const num = Number(number)
  if (typeof num !== 'number') {
    return console.error('参数必须是数字')
  }

  const sign = Math.sign(num)
  const hour = num >= ONE_HOUR_SEC ? `${parseInt(num / ONE_HOUR_SEC)}` : ''
  const minute = num >= ONE_MINUTE_SEC ? parseInt((num % ONE_HOUR_SEC) / ONE_MINUTE_SEC) : ''
  const second = parseInt(num % ONE_MINUTE_SEC)
  let result = second < 10 ? `0${second}` : second
  result = minute ? `${minute < 10 ? '0' + minute : minute}:${result}` : `00:${result}`
  result = hour ? `${hour}:${result}` : result
  result = sign < 0 ? `-${result}` : result

  return result
}

/**
 * 计算距离当前时间还有多少天
 * @param {*} endTime
 * @returns
 */
export function toNow(endTime) {
  const DAY = 1000 * 60 * 60 * 24
  const HOUR = 1000 * 60 * 60
  const MINUTE = 1000 * 60
  const now = +new Date()
  const diff = +new Date(endTime) - now
  let days, hours, minutes, seconds

  if (diff > 0) {
    days = Math.floor(diff / DAY)
    hours = Math.floor((diff % DAY) / HOUR)
    minutes = Math.floor((diff % HOUR) / MINUTE)
    seconds = Math.floor((diff % MINUTE) / 1000)

    if (days > 0) {
      return `还剩 ${days} 天`
    } else if (hours > 0) {
      return `还剩 ${hours} 小时`
    } else if (minutes > 0) {
      return `还剩 ${minutes} 分`
    } else {
      return `还剩 ${seconds} 秒`
    }
  } else {
    return '已过期'
  }
}
